// Read the published Pumper offer; Shopify remains responsible for applying discounts.
(() => {
  'use strict';
  let pending;
  let loadedAt = 0;
  async function offer() {
    if (!pending || Date.now() - loadedAt > 60000) {
      loadedAt = Date.now();
      pending = (async () => {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'products/kesar-kulfi-fermented-yeast-protein-powder-15-serve-bag-540g', { credentials: 'same-origin' });
        if (!response.ok) throw Error('Offer unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(page.querySelector('#pmpr_offer_details')?.getAttribute('data-prvw_data') || '{}').metafieldData;
        if (data?.status !== 'published' || data.discountFunctionNamespace !== 'pumper-qb-v3' || data.market?.enabled || data.subscriptions) throw Error('Choose your pack on the product page.');
        return data;
      })();
      pending.catch(() => { pending = null; });
    }
    return pending;
  }
  async function prepare(form, body) {
    const data = await offer();
    const id = 'gid://shopify/Product/' + form.dataset.rkBundleProduct;
    const tier = data.quantity.findIndex(q => Number(q) === 1);
    const extra = data.extension?.[tier];
    if (!data.productId.includes(id) || tier < 0 || data.price[tier] !== 'percentage' || data.bogoOffer?.[tier]?.isEnabled || (extra && ['freeGift', 'upsell', 'mixMatch', 'freeShipping'].some(k => extra[k]?.length))) throw Error('Choose your pack on the product page.');
    const discount = Number(data.discount[tier]);
    if (!Number.isFinite(discount) || discount <= 0 || discount >= 100) throw Error('Choose your pack on the product page.');
    if (body) {
      body.set('quantity', '1');
      body.set('product-id', form.dataset.rkBundleProduct);
      body.set('properties[__pumper_bundles]', data.offerId + '.' + tier);
    }
    const image = form.closest('article')?.querySelector('.rk-card-image');
    if (image && !image.querySelector('.rk-ribbon')) {
      const ribbon = document.createElement('span');
      ribbon.className = 'rk-ribbon';
      ribbon.textContent = Math.round(discount) + '% OFF';
      image.append(ribbon);
    }
    const price = form.closest('article')?.querySelector('.rk-price, [data-rk-bundle-price]');
    if (price) {
      const base = Number(form.dataset.rkBasePrice);
      const sale = base - Math.round(base * discount / 100);
      // Match Pumper's display preference without changing the discount or cart amounts.
      const fractionDigits = data.removeDecimal === true ? 0 : 2;
      const format = n => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.Shopify?.currency?.active || 'INR', minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(n / 100);
      const was = document.createElement('s');
      was.textContent = format(base);
      const now = document.createElement('strong');
      now.textContent = format(sale);
      price.replaceChildren(was, document.createTextNode(' '), now);
    }
  }
  window.rkPrepareCardBundle = prepare;
  function initialize() {
    document.querySelectorAll('[data-rk-bundle-product]').forEach(form => {
      prepare(form).catch(() => {
        const button = form.querySelector('[type="submit"]');
        if (button) button.textContent = 'CHOOSE PACK';
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('cart:updated', initialize);
})();
